import { useTheme } from '@gousto-internal/citrus-react'
import { canUseWindow } from '@library/environment'
import { useEffect, useState } from 'react'

const getIsDesktop = (desktopBreakpoint: number) =>
  canUseWindow() ? window.innerWidth >= desktopBreakpoint : true

/**
 * True once the viewport reaches Citrus's `Large` breakpoint (1024px) — for layouts that switch
 * to side-by-side there. `@library/dom`'s `useDeviceType` isn't a fit: its "desktop" bucket starts
 * at 768px, one tier earlier.
 */
export const useIsDesktopBreakpoint = (): boolean => {
  const { theme } = useTheme()
  const desktopBreakpoint = parseInt(theme.tokens.breakpoints[2], 10)

  const [isDesktop, setIsDesktop] = useState(() => getIsDesktop(desktopBreakpoint))

  useEffect(() => {
    if (!canUseWindow()) return

    const onResize = () => setIsDesktop(getIsDesktop(desktopBreakpoint))
    window.addEventListener('resize', onResize)

    return () => window.removeEventListener('resize', onResize)
  }, [desktopBreakpoint])

  return isDesktop
}
